import React, { Component } from "react";
import { Input, FormGroup, FormFeedback } from "reactstrap";
import i18n from "../i18n";

class Valert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAlert: props.display,
      invalid: false,
    };
    this.changeStatus = this.changeStatus.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.clickPositive = this.clickPositive.bind(this);
    this.clickNegative = this.clickNegative.bind(this);
    this.clickThirdAction = this.clickThirdAction.bind(this);

    this.getInputValue = this.getInputValue.bind(this);
  }
  // changeStatus() {
  //   this.setState({
  //     showAlert: !this.state.showAlert,
  //     inputValue: this.props.inputValue,
  //   });
  // }
  changeStatus() {
    this.setState(
      (prev) => ({
        showAlert: !prev.showAlert,
        inputValue: this.props.inputValue,
      }),
      () => {
        // ✅ Focus ONLY when opening
        if (this.state.showAlert && this.props.inputField && this.inputRef) {
          setTimeout(() => {
            this.inputRef.focus();
          }, 0);
        }
      }
    );
  }


  closeAlert() {
    this.setState({ showAlert: false });
    this.props.onClose();
  }
  componentDidUpdate(prevProp) {
    if (prevProp.display != this.props.display) {
      this.setState({
        showAlert: this.props.display,
      });
    }
  }
  componentDidMount() {
    this.props.onRef && this.props.onRef(this);
  }
  componentWillReceiveProps(newProps) {
    this.setState({ inputValue: newProps.inputValue });
  }
  onDismiss() {
    this.props.onDismiss && this.props.onDismiss();
  }
  async clickPositive() {
    this.props.positiveAction && (this.props.positiveAction());
    if (!this.props.disableAutoClose) {
      this.changeStatus();
      this.onDismiss();
    }
  }
  async clickNegative() {
    this.props.negativeAction && (await this.props.negativeAction());
    if (!this.props.disableAutoClose) {
      this.changeStatus();
      this.onDismiss();
    }
    this.setState({ invalid: false });
  }
  async clickThirdAction() {
    this.props.ThirdAction && (await this.props.ThirdAction());
    if (!this.props.disableAutoClose) {
      this.changeStatus();
      this.onDismiss();
    }
  }
  getInputValue() {
    return this.state.inputValue;
  }
  isInt(value) {
    return (
      !isNaN(value) &&
      parseInt(Number(value)) == value &&
      !isNaN(parseInt(value, 10))
    );
  }

  render() {
    const { question, children } = this.props;
    let valertSectionDisplay = "none";
    if (this.state.showAlert) {
      valertSectionDisplay = "flex";
    } else {
      valertSectionDisplay = "none";
    }
    return (
      <section
        className="valertSection"
        style={{ display: valertSectionDisplay, zIndex: this.props.zIndex || 15, }}
      >
        <div className="valertContainer">
          {this.props.crossIcon && (
            <div style={{ marginRight: "3px" }} onClick={this.clickNegative}>
              <i className="fas fa-times closeIcon"></i>
            </div>
          )}
          {/* Prompt Title */}
          {this.props.title &&
            <h4 style={{ fontWeight: 700 }}>
              {this.props.title}
            </h4>
          }

          {/* Prompt Text */}
          <p>{question}</p>
          {this.props.inputField && (
            <div className="inputContainer">
              {this.props.inputType == "number" ? (
                <FormGroup className="position-relative">
                  <Input
                    invalid={this.props.showInvalid ? this.state.invalid : false}
                    type="text"
                    autoComplete="off"
                    value={this.state.inputValue || ''}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      // Allow empty string (for clearing input) and check if the input is a valid number
                      if (inputValue === "" || /^\d*$/.test(inputValue)) {
                        this.setState({ inputValue, invalid: false });
                        this.props.onChangeInput && this.props.onChangeInput(e);
                      }
                    }}
                    innerRef={(el) => (this.inputRef = el)}

                  />
                  {this.state.invalid === true && this.props.invalidText ? (
                    <FormFeedback tooltip>
                      {this.props.invalidText}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              ) : (
                <Input
                  type="text"
                  autoComplete={false}
                  value={this.state.inputValue}
                  plaseholder="plaseholder"
                  onChange={(e) =>
                    this.setState({ inputValue: e.target.value })
                  }
                />
              )}
            </div>
          )}
          {children}
          <div className="ButtonsContainer">
            <button
              type="button"
              // disabled={this.state.invalid}
              disabled={
                this.props.okBtn
                  ? this.props.okBtn
                  : this.props.max &&
                    (this.state.inputValue < 1 ||
                      this.state.inputValue > this.props.max ||
                      this.isInt(this.state.inputValue) === false)
                    ? true
                    : false
              }
              className="btn btn-primary"
              onClick={this.clickPositive}
            >
              {this.props.positiveText
                ? this.props.positiveText
                : i18n.t("general.POSITIVE_PROMPT_TEXT")}
            </button>
            {!this.props.readOnly && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.clickNegative}
              >
                {this.props.negativeText
                  ? this.props.negativeText
                  : i18n.t("general.CANCEL")}
              </button>
            )}
            {this.props.thirdActionText && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.clickThirdAction}
              >
                {this.props.thirdActionText}
              </button>
            )}
          </div>
        </div>
      </section>
    );
  }
}
export default Valert;



// WEBPACK FOOTER //
// ./src/components/Valert.js